var exports = {
  "zp": "spinnerWrapper__ihnetr",
  "KL": "spinnerInner__KZ0_1v",
  "ug": "staticSpinner__Al6OgS",
  "Ex": "checksSpinnerWrapper__tn1N1W",
};

module.exports = exports;
